var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    display: "inline-block",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.666 13.333V12h1.833l-.266-.233c-.578-.511-.984-1.095-1.217-1.75a5.878 5.878 0 01-.35-1.984c0-1.233.37-2.33 1.108-3.292a5.213 5.213 0 012.892-1.908v1.4c-.8.29-1.444.78-1.933 1.475a3.947 3.947 0 00-.734 2.325c0 .5.095.986.284 1.458.189.473.483.909.883 1.309l.167.167V9.333h1.333v4h-4zm6.667-.166v-1.4c.8-.29 1.444-.78 1.933-1.475.489-.695.733-1.47.733-2.325 0-.5-.094-.987-.283-1.459a3.895 3.895 0 00-.883-1.308l-.167-.167v1.634H9.333v-4h4V4h-1.834l.267.233c.544.545.942 1.136 1.192 1.775.25.64.375 1.292.375 1.959 0 1.233-.37 2.33-1.109 3.291a5.208 5.208 0 01-2.891 1.909z",
    fill: "#802626"
  })));
}
export default SvgRefresh;